/**
 * The data associated with an attribution record
 */
export type ATTRIBUTION_PAYLOAD = {
  channelType: CHANNEL_TYPE
  channel?: string
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
  utmProduct?: string
  utmAudience?: string
  utmContent?: string
  utmTerm?: string
  category?: ATTRIBUTION_CATEGORY
  data?: object
}

/**
 * The type of channel from which a loan application was created
 */
export enum CHANNEL_TYPE {
  API = 'API',
  WEB = 'WEB',
  PARTNER_DASHBOARD = 'PARTNER_DASHBOARD',
}

/**
 * The category filed in attribution table
 */
export enum ATTRIBUTION_CATEGORY {
  DEALER = 'Dealer',
  AFFILIATE = 'Affiliate',
  PAID_CHANNEL = 'Paid channel',
  REFERRAL_PARTNER = 'Referral partner',
  ORGANIC = 'Organic',
  REENGAGEMENT = 'Re-engagement',
  DIRECT = 'Direct',
}
